<template>
  <div class="auto-login-container">
    <div v-if="loading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Загрузка...</span>
      </div>
      <p class="mt-3">Выполняется вход в систему...</p>
    </div>

    <div v-else-if="error" class="error-container">
      <div class="alert alert-danger" role="alert">
        <h4 class="alert-heading">Ошибка входа!</h4>
        <p>{{ error }}</p>
        <hr>
        <p class="mb-0">
          <router-link to="/" class="btn btn-primary">Вернуться на главную</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AutoLogin',
  data() {
    return {
      loading: true,
      error: null
    };
  },
  async mounted() {
    // Проверяем, есть ли параметры в URL
    const hash = window.location.hash;
    if (hash.includes('auto-login') && hash.includes('login=')) {
      await this.performAutoLogin();
    } else {
      this.error = 'Отсутствуют параметры логина или пароля в URL';
      this.loading = false;
    }

    // Добавляем обработчик для случаев навигации браузера (back/forward)
    window.addEventListener('popstate', this.handlePopState);
  },

  beforeDestroy() {
    // Удаляем обработчик при уничтожении компонента
    window.removeEventListener('popstate', this.handlePopState);
  },
  // Добавляем обработку повторного использования URL
  watch: {
    // Следим за изменениями в URL
    '$route'(to, from) {
      if (to.name === 'auto-login') {
        // При повторном переходе на тот же роут перезагружаем компонент
        this.loading = true;
        this.error = null;
        this.performAutoLogin();
      }
    }
  },
  // Добавляем обработку перед входом в роут
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Принудительно выполняем автологин при каждом входе в роут
      vm.loading = true;
      vm.error = null;
      vm.performAutoLogin();
    });
  },
  methods: {
    // Обработчик для случаев навигации браузера (back/forward)
    handlePopState() {
      const hash = window.location.hash;
      if (hash.includes('auto-login') && hash.includes('login=')) {
        this.loading = true;
        this.error = null;
        this.performAutoLogin();
      }
    },

    async performAutoLogin() {
      try {
        // Получаем параметры из URL (поддерживаем как query параметры, так и хэш)
        let login, password;

        // Сначала пробуем получить из query параметров
        const urlParams = new URLSearchParams(window.location.search);
        login = urlParams.get('login');
        password = urlParams.get('password');

        // Если не найдены в query, пробуем из хэша
        if (!login || !password) {
          const hash = window.location.hash;
          if (hash.includes('?')) {
            const hashParams = new URLSearchParams(hash.split('?')[1]);
            login = login || hashParams.get('login');
            password = password || hashParams.get('password');
          }
        }

        if (!login) {
          this.error = 'Отсутствует параметр логина в URL';
          this.loading = false;
          return;
        }

        // Если пароль не передан, используем стандартный
        if (!password) {
          password = 'Qwerqwer1!';
        }

        // Выполняем автологин через Django view
        const response = await fetch(`/auto-login/?login=${encodeURIComponent(login)}&password=${encodeURIComponent(password)}`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Ошибка автологина');
        }

        // Задержка для гарантии создания сессии
        await new Promise(resolve => setTimeout(resolve, 100));

        // Получаем информацию о пользователе
        try {
          await this.$store.dispatch('user/fetchUserInfo');
        } catch (error) {
          console.error('Ошибка получения информации о пользователе:', error);
        }

        try {
          await this.$store.dispatch('fetchProjects');
        } catch (error) {
          console.error('Ошибка получения проектов:', error);
        }

        // Попап отключен - код метода showCredentialsPopup оставлен для возможного будущего использования

        // Перенаправляем на главную страницу
        this.$router.push({ name: 'positions' });

      } catch (error) {
        console.error('Ошибка автовхода:', error);
        this.error = error.message || 'Произошла ошибка при входе в систему';
        this.loading = false;
      }
    },

    showCredentialsPopup(login, password) {
      // Создаем popup с данными для входа
      const popup = document.createElement('div');
      popup.className = 'credentials-popup';
      popup.innerHTML = `
        <div class="credentials-popup-content">
          <div class="credentials-popup-header">
            <h5>🔐 Вы вошли в тестовый аккаунт</h5>
            <button type="button" class="close-btn" onclick="this.closest('.credentials-popup').remove()">
              <span>&times;</span>
            </button>
          </div>
          <div class="credentials-popup-body">
            <div class="credential-field">
              <div class="credential-text">
                Логин: ${login}<br>
                Пароль: ${password}
              </div>
              <button class="btn btn-primary copy-btn" onclick="copyToClipboard('Данные для авторизации в демо-аккаунте СКМ-Абель:\\nСсылка: https://abelpro.ru/#/\\nЛогин: ${login}\\nПароль: ${password}')">
                Скопировать
              </button>
            </div>
            <p class="text-muted text-center">
              💡 Сохраните эти данные —<br>они понадобятся при следующем входе.
            </p>
            <hr>
            <div class="text-center mt-4">
              <button class="btn btn-primary btn-lg copy-link-btn" onclick="copyToClipboard('Привет!\\nЯ посмотрел презентацию нового сервиса конкурентного мониторинга в контекстной рекламе — мне он показался интересным, рекомендую тебе тоже глянуть, когда будет время.\\n\\nВот данные для входа:\\nСсылка: https://abelpro.ru/#/\\nЛогин: ${login}\\nПароль: ${password}\\n\\nЕсли будешь смотреть — дай знать, интересно будет обсудить впечатления.')">
               Поделиться
              </button>
              <p class="text-muted mt-3">
                📤 Поделитесь с коллегами —<br>возможно, это будет полезно и им!
              </p>
            </div>
          </div>
        </div>
      `;

      // Cтили
      const style = document.createElement('style');
      style.textContent = `
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap');

        .credentials-popup {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          font-family: 'Roboto', sans-serif;
        }
        .credentials-popup-content {
          background: white;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
          max-width: 500px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          font-family: 'Roboto', sans-serif;
        }
        .credentials-popup-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem 1.5rem 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          font-family: 'Roboto', sans-serif;
        }
        .credentials-popup-header h5 {
          margin: 0;
          color: #495057;
          font-weight: 600;
          font-family: 'Roboto', sans-serif;
          font-size: 1.1rem;
        }
        .credentials-popup-header .close-btn {
          background: #007bff;
          border: none;
          border-radius: 50%;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: white;
          font-size: 1.2rem;
          font-weight: bold;
          transition: background-color 0.2s;
          font-family: 'Roboto', sans-serif;
        }
        .credentials-popup-header .close-btn:hover {
          background: #0056b3;
        }
        .credentials-popup-body {
          padding: 1.5rem;
          font-family: 'Roboto', sans-serif;
        }
        .credential-field {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1rem;
          padding: 1rem;
          background: #f8f9fa;
          border-radius: 8px;
          border: 1px solid #e9ecef;
          font-family: 'Roboto', sans-serif;
          min-height: 60px;
        }
        .credential-text {
          flex: 1;
          font-family: 'Roboto', sans-serif;
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.5;
          color: #495057;
        }
        .copy-btn {
          background: #007bff;
          border: none;
          border-radius: 6px;
          padding: 0.75rem 1.5rem;
          color: white;
          font-weight: 500;
          transition: background-color 0.2s;
          white-space: nowrap;
          font-family: 'Roboto', sans-serif;
          font-size: 0.9rem;
          height: fit-content;
          align-self: center;
        }
        .copy-btn:hover {
          background: #0056b3;
        }
        .copy-link-btn {
          background: #007bff;
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          color: white;
          font-weight: 500;
          transition: background-color 0.2s;
          font-family: 'Roboto', sans-serif;
          font-size: 1rem;
        }
        .copy-link-btn:hover {
          background: #0056b3;
        }
        .text-center {
          text-align: center;
          font-family: 'Roboto', sans-serif;
        }
        .text-muted {
          color: #6c757d;
          font-family: 'Roboto', sans-serif;
          font-weight: 400;
        }
        .mt-3 {
          margin-top: 1rem;
        }
        .mt-4 {
          margin-top: 1.5rem;
        }
        hr {
          border-color: #e9ecef;
          margin: 1.5rem 0;
        }
      `;

      // Функция копирования из формы (логин/пароль/ссылка)
      window.copyToClipboard = function(text) {
        navigator.clipboard.writeText(text).then(() => {
          // Уведомление о копировании
          const notification = document.createElement('div');
          notification.className = 'copy-notification';
          notification.textContent = 'Скопировано!';
          notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #28a745;
            color: white;
            padding: 0.5rem 1rem;
            border-radius: 4px;
            z-index: 10000;
            animation: slideIn 0.3s ease-out;
          `;
          document.body.appendChild(notification);

          setTimeout(() => {
            notification.remove();
          }, 2000);
        });
      };

      document.head.appendChild(style);
      document.body.appendChild(popup);

      // Автоматически закрыть popup через 60 секунд
      setTimeout(() => {
        if (popup.parentNode) {
          popup.remove();
        }
      }, 60000);
    }
  }
};
</script>

<style scoped>
.auto-login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8f9fa;
}

.loading-container {
  text-align: center;
}

.error-container {
  max-width: 500px;
  margin: 0 auto;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
